import { Button, Form, Input, Layout, message, Image } from "antd";
import { useMemo, useState } from "react";
import { useOrderId } from "../../../hooks/UseOrderId";
import { CheckoutInfoResponse } from "../../../types/CheckoutInfoResponse";
import InfoCard from "../shared/InfoCard";

import ovoImg from "../../../assets/ovo.png";
import { usePostCheckoutApi } from "../../../api";
import WrappedCard from "../../antd/WrappedCard";
import { ProviderTypeEnum } from "../../../types/ProviderTypeEnum";

type OVOTypeProps = {
  getCheckoutInfoData: CheckoutInfoResponse;
};

const { Content } = Layout;

const IdOvoMode = ({ getCheckoutInfoData }: OVOTypeProps) => {
  const id = useOrderId();
  const { loading: putLoading, executePost } = usePostCheckoutApi(id);

  const amountInfoList = useMemo(() => {
    return [
      {
        label: "Jumlah yang Harus Dibayar",
        value: getCheckoutInfoData?.orderAmount
      }
    ];
  }, [getCheckoutInfoData]);

  // NOTICE: ant design
  const [submitCheckout, setSubmitCheckout] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const onFormFinish = (values: any) => {
    executePost({
      data: {
        id: id,
        customerPhone: values.customerPhone,
        providerType: ProviderTypeEnum.OVO
      }
    })
      .then(() => {
        setSubmitCheckout(true);
      })
      .catch((error) => {
        messageApi.error("Failed:" + error?.response?.data?.title);
      });
  };

  const onButtonClick = () => {
    form.submit();
  };

  return (
    <>
      {contextHolder}
      <Content>
        <InfoCard
          cardTitle="Informasi"
          descTitle="jumlah"
          itemList={amountInfoList}
        />
        <WrappedCard
          cardTitle={<Image src={ovoImg} />}
          cardProps={{
            headStyle: { border: "none", paddingTop: "1rem" }
          }}
        >
          {!submitCheckout && (
            <Form
              form={form}
              layout="vertical"
              initialValues={{ phone: "" }}
              onFinish={onFormFinish}
            >
              <Form.Item
                name="customerPhone"
                label="Namor OVOType"
                rules={[
                  {
                    required: true,
                    message: "Please input your phone number!"
                  },
                  {
                    max: 14,
                    message: "Phone number cannot be longer than 14 characters"

                  },
                  {
                    min: 8,
                    message: "Phone number must be at least 8 characters"

                  }
                ]}
              >
                <Input
                  placeholder="0821 XXXX XXXX"
                  style={{ width: "200px" }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  onClick={onButtonClick}
                  loading={putLoading}
                >
                  Bayer
                </Button>
              </Form.Item>
            </Form>
          )}

          {submitCheckout && (
            <div>
              <p> Perhatian</p>
              <ul>
                <li>
                  Klik tombol notifikasi di bagian kanan atas layar di OVOType
                </li>
                <li>Klik notifikasi/pesan untuk melakukan pembayaran</li>
                <li>Pastikan semua info sudah benar</li>
                <li>Lakukan pembayaran</li>
                <li>Selesai</li>
              </ul>
            </div>
          )}
        </WrappedCard>
      </Content>
    </>
  );
};

export default IdOvoMode;
